import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";
import { revokeAllProtectedUrls } from "../utils/protectedFiles";

export default function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      // 1) Purge des objectURL (logos/images protégées)
      try { revokeAllProtectedUrls(); } catch { }

      // 2) Nettoyage des tokens
      try {
        localStorage.removeItem("token");
        localStorage.removeItem("authToken");
        localStorage.removeItem("jwt");
      } catch { }

      // 3) Retrait du header global axios
      if (axiosInstance?.defaults?.headers?.common?.Authorization) {
        delete axiosInstance.defaults.headers.common.Authorization;
      }

      // 4) Notifie le Provider (même onglet + autres onglets)
      //  - 'storage' est écouté par d'autres onglets
      //  - 'auth-changed' est écouté par cet onglet
      window.dispatchEvent(new Event("storage"));
      window.dispatchEvent(new Event("auth-changed"));
    } finally {
      toast.success("Déconnexion réussie !");
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  return null;
}
